import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { HowToPlayPage } from "@/components/HowToPlayPage";
import { powerballHowToPlayData } from "@/data/how-to-play-powerball";
import { buildFaqJsonLd } from "@/lib/faq-jsonld";

export const Route = createFileRoute("/powerball/how-to-play")({
  head: () => buildSeo({
    title: "How to Play Powerball: Rules, Prizes & Odds | USA Lottery Club",
    description: powerballHowToPlayData.meta.description,
    path: "/powerball/how-to-play",
    type: "article",
    jsonLd: buildFaqJsonLd(powerballHowToPlayData),
  }),
  component: () => <HowToPlayPage {...powerballHowToPlayData} />,
});
